const ServiceRequest = {
  'pages_servicerequest_list.path': 'SR 목록',
  'pages_servicerequest_info.path': 'SR 상세',


  'pages_servicerequest.status.done': '완료',
  'pages_servicerequest.status.processing': '진행중',

  'pages_servicerequest.division.total': '총',
  'pages_servicerequest.division.all': '상태 선택',
  'pages_servicerequest.division.open': '오픈',
  'pages_servicerequest.division.pending': '처리 중',
  'pages_servicerequest.division.customer_pending': '고객답변대기',
  'pages_servicerequest.division.aws_pending': 'AWS 진행중',
  'pages_servicerequest.division.solved': '답변 완료',
  'pages_servicerequest.division.closed': '종료',


  'pages_servicerequest.list.column.header.number': 'No.',
  'pages_servicerequest.list.column.header.customerName': '고객명',
  'pages_servicerequest.list.column.header.requester': '요청자',
  'pages_servicerequest.list.column.header.receiveDate': '접수일시',
  'pages_servicerequest.list.column.header.updateDate': '업데이트일시',
  'pages_servicerequest.list.column.header.subject': '제목',
  'pages_servicerequest.list.column.header.status': '상태',

  'pages_servicerequest.total.chart.header': '전체 지원 요청 추이',
  'pages_servicerequest.total.chart.tooltip': '고객 지원 요청(SR) 정보가 나타납니다.<br/>그래프를 클릭하면 클릭한 날짜의 세부 목록이 나타납니다.',

  'pages_servicerequest.topfive.chart.header': '고객별 지원 요청 추이(Top 5)',
  'pages_servicerequest.topfive.chart.tooltip': '일별 고객 지원 요청(SR) 중 건수가 가장 많은 </br>상위 5개 고객 목록이 나타납니다.<br/>그래프를 클릭하면 클릭한 날짜의 세부 목록이 나타납니다.',

  'pages_servicerequest.info.subject': '제목',
  'pages_servicerequest.info.customerName': '고객명',
  'pages_servicerequest.info.id': '아이디',
  'pages_servicerequest.info.status': '상태',
  'pages_servicerequest.info.receiveDate': '접수일시',
  'pages_servicerequest.info.requester': '요청자',
  'pages_servicerequest.info.requesterEamil': '요청자 이메일',
  'pages_servicerequest.info.updateDate': '업데이트일시',
  'pages_servicerequest.info.responderName': '담당자',
  'pages_servicerequest.info.link': '링크',
  'pages_servicerequest.info.content': '내용',
  'pages_servicerequest.info.conversation': '댓글'
  
}

export default ServiceRequest




// WEBPACK FOOTER //
// ./src/lang/servicerequest/ServiceRequest.kr.js